// extracted by mini-css-extract-plugin
export default {"zoom":"tka-z","zoomContent":"uka-z"};